import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { useCustomerProjects } from "@/hooks/useCustomerPortal";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Search, FolderOpen } from "lucide-react";

const CustomerProjects = () => {
  const navigate = useNavigate();
  const { data: projects, isLoading } = useCustomerProjects();
  const [search, setSearch] = useState("");

  const filtered = (projects ?? []).filter((p) =>
    p.name.toLowerCase().includes(search.toLowerCase()) ||
    p.project_number?.toLowerCase().includes(search.toLowerCase())
  );

  if (isLoading) {
    return <div className="flex items-center justify-center py-20"><div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" /></div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Projects</h1>
          <p className="text-muted-foreground text-sm">{filtered.length} project{filtered.length !== 1 ? "s" : ""}</p>
        </div>
      </div>

      <div className="relative max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input placeholder="Search projects..." className="pl-9" value={search} onChange={(e) => setSearch(e.target.value)} />
      </div>

      {filtered.length === 0 ? (
        <Card><CardContent className="py-12 text-center text-muted-foreground"><FolderOpen className="mx-auto h-10 w-10 mb-2 opacity-40" /><p>No projects found</p></CardContent></Card>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((p) => (
            <Card key={p.id} className="cursor-pointer hover:border-primary/30 transition-colors" onClick={() => navigate(`/portal/customer/projects/${p.id}`)}>
              <CardContent className="p-4 space-y-2">
                <div className="flex items-start justify-between">
                  <div>
                    <p className="font-medium">{p.name}</p>
                    <p className="text-xs text-muted-foreground">{p.project_number}</p>
                  </div>
                  <Badge variant="outline" className="capitalize text-xs">{p.status}</Badge>
                </div>
                {(p.city || p.state) && (
                  <p className="text-xs text-muted-foreground">{[p.city, p.state].filter(Boolean).join(", ")}</p>
                )}
                <div className="flex gap-4 text-xs text-muted-foreground">
                  {p.start_date && <span>Start: {p.start_date}</span>}
                  {p.scheduled_completion && <span>Target: {p.scheduled_completion}</span>}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomerProjects;
